// extracted by mini-css-extract-plugin
module.exports = {"birthdayContainer":"ProfileEditDialog_birthdayContainer_1Y_VR","birthdayInput":"ProfileEditDialog_birthdayInput_2qlfm"};